import { AttachmentPreviewMethod } from 'owa-attachment-data';
import { SaveToCloudStatus } from 'owa-attachment-savetocloud';
import { ClientItemId } from 'owa-client-ids';
import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import { lazyGetSxSViewStateFromElement } from 'owa-sxs';
import {
    lazyOnPreviewOperationFinished,
    lazyOnPreviewOperationStart,
    lazyShowSxS,
    onSxSChangeOrClose,
    PreviewPaneSelectionSource,
    SxSCustomization,
    sxsStore,
} from 'owa-sxs-store';
import { ImageGalleryItem, lazySetImagePreviewState, SxSViewState } from 'owa-sxsdata';
import { SxSReadingPaneInitializeMethod } from '../types/SxSReadingPaneStrategy';
import insertSxSV2IntoDomHelper from '../utils/insertSxSV2IntoDomHelper';
import { throwUserError } from '../utils/throwUserError';
import { initializeReadingPaneInSxS } from './internalActions';

export default async function previewImageInSxS(
    item: ImageGalleryItem,
    imageGallery: ImageGalleryItem[],
    parentItemId: ClientItemId,
    target: HTMLElement | SxSViewState
) {
    insertSxSV2IntoDomHelper.run();

    const onPreviewOperationStart = await lazyOnPreviewOperationStart.import();
    const onPreviewOperationFinished = await lazyOnPreviewOperationFinished.import();

    let sxsViewState: SxSViewState = null;
    if (target instanceof HTMLElement) {
        const getSxSViewState = await lazyGetSxSViewStateFromElement.import();
        sxsViewState = getSxSViewState(target);
    } else {
        sxsViewState = target;
    }

    if (!sxsViewState) {
        sxsViewState = sxsStore.viewState;
    }

    const optionalParameters = {
        downloadUrl: item.downloadUrl,
        downloadShouldOpenNewTab: false,
        useHighContrastCommandBar: false,
        id: item.id,
    };

    const currentPendingOperation = {
        id: `${new Date().getTime()}_${Math.floor(Math.random() * 1000)}`,
        attachmentId: item.id,
    };
    onPreviewOperationStart(currentPendingOperation);

    try {
        // do not need to wait for edit mode/compose as this function should only be triggered from reading pane

        const showSxS = await lazyShowSxS.import();
        const setImagePreviewState = await lazySetImagePreviewState.import();

        if (
            !sxsStore.pendingPreviewOperation ||
            currentPendingOperation.id !== sxsStore.pendingPreviewOperation.id
        ) {
            throwUserError('Preview changed before loading finished');
        }

        initializeReadingPaneInSxS(
            {
                method: SxSReadingPaneInitializeMethod.CopyMailReadingPaneContainer,
            },
            PreviewPaneSelectionSource.ReadingPane,
            null /* parentItemId */,
            null /* instrumentationContext */
        );
        setImagePreviewState(sxsViewState, item.previewUrl, imageGallery, optionalParameters);
        showSxS(
            sxsStore.shouldShow ? null : SxSCustomization.Mail,
            {
                previewMode: AttachmentPreviewMethod.Image,
                attachmentId: item.id,
                selectionSource: PreviewPaneSelectionSource.ReadingPane,
                isCloudy: false,
                saveToCloudStatus: SaveToCloudStatus.disabled,
                textPreviewReadMode: GetAttachmentTextPreviewReadMode.AutoDetect,
            },
            {
                editAllowed: false,
                itemId: parentItemId,
                isDraft: false,
            },
            null // selectedLinkId
        );
        onSxSChangeOrClose(null);
        onPreviewOperationFinished();
    } catch (error) {}
}
